const translation: Record<string, string> = {
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.ranking': '热门排行',
  'nav.latest': '最新更新',
  'nav.about': '关于我们',
  'hero.announcement': '每日更新 · 海量韩漫资源 · 完全免费',
  'hero.title': '韩漫在线',
  'hero.subtitle': '好看的韩国漫画大全',
  'hero.description': '汇聚全网热门韩国漫画，更新及时、画质高清，为您打造极致的在线阅读体验。无论你喜欢浪漫爱情还是热血冒险，这里都有属于你的故事。',
  'hero.primaryBtn': '开始阅读',
  'hero.secondaryBtn': '了解更多',
  'section.hotRecommend': '热门推荐',
  'section.latestUpdate': '最新更新',
  'section.categoryExplore': '探索分类',
  'section.testimonial': '读者口碑',
  'section.faq': '常见问题',
  'badge.new': '新',
  'badge.ongoing': '连载中',
  'badge.completed': '已完结',
  'status.ongoing': '连载中',
  'status.completed': '已完结',
  'label.rating': '评分',
  'label.chapter': '话',
  'label.works': '部作品',
  'button.readNow': '立即阅读',
  'button.viewAll': '查看全部',
  'button.loadMore': '加载更多',
  'footer.brandDesc': '韩漫在线 - 韩国漫画免费阅读平台，每日更新，海量资源，高清画质，随时随地畅享阅读乐趣。',
  'footer.categories': '漫画分类',
  'footer.quickLinks': '快速链接',
  'footer.support': '帮助支持',
  'footer.copyright': '韩漫在线. 保留所有权利.',
  'footer.subscribeTitle': '订阅更新',
  'footer.subscribeDesc': '获取最新漫画更新通知和推荐',
  'footer.subscribePlaceholder': '输入您的邮箱',
  'footer.subscribeBtn': '订阅',
  'seo.homeTitle': '韩漫在线_免费观看韩国漫画_好看的漫画大全_韩国漫画网站',
  'seo.homeDesc': '韩漫在线,免费观看韩国漫画,好看的漫画大全,韩国漫画网站。韩国漫画网站支持韩漫在线免费观看，包含好看的漫画大全，更新频繁体验佳，让您随时随地探索各种故事并享受无限阅读乐趣。',
  'seo.keywords': '韩漫在线,免费观看韩国漫画,好看的漫画大全,韩国漫画网站',
};

export default translation;